import * as React from 'react';
import {noEmpty} from '@packages/utilities/component';
import {styledDiv, type Theme} from '@packages/utilities/styled';
import {pixel} from '@packages/utilities/inline-style-utils';
import type {CSSProperties} from '@packages/utilities/css-properties-type';

type StylingType = {
  theme: Theme;
  style?: CSSProperties;
  ['data-automation-id']?: string;
};

const variants = {
  dim: ({theme}: StylingType) => ({
    color: theme.colors.foregroundDim,
  }),
  muted: ({theme}: StylingType) => ({
    color: theme.colors.foregroundDimmer,
  }),
  vivid: ({theme}: StylingType) => ({
    color: theme.colors.foregroundVivid,
  }),
  accent: ({theme}: StylingType) => ({
    color: theme.colors.accentVivid,
  }),
  white: ({theme}: StylingType) => ({
    color: theme.colors.white,
  }),
} as const;

type TextProps = {
  dim?: boolean;
  muted?: boolean;
  vivid?: boolean;
  accent?: boolean;
  white?: boolean;
  style?: CSSProperties;
  ['data-automation-id']?: string;
  children: string | React.ReactNode;
};

// @ts-expect-error - TS2322 - Type 'AbstractComponent<Diff<StylingType, { style?: StyleObject; }>, any>' is not assignable to type 'ComponentType<TextProps>'.
export const Heading: React.ComponentType<TextProps> = noEmpty(
  styledDiv(
    ({theme, style, 'data-automation-id': dataAutomationId}: StylingType) => ({
      color: theme.Text.headingColor,
      ...theme.typography.heading,
      ...style,
      lineHeight: pixel(theme.typography.heading.lineHeight),
      dataAutomationId,
    }),
    variants
  )
);

// @ts-expect-error - TS2322 - Type 'AbstractComponent<Diff<StylingType, { style?: StyleObject; }>, any>' is not assignable to type 'ComponentType<TextProps>'.
export const Subheading: React.ComponentType<TextProps> = noEmpty(
  styledDiv(
    ({theme, style, 'data-automation-id': dataAutomationId}: StylingType) => ({
      color: theme.Text.headingColor,
      ...theme.typography.subheading,
      ...style,
      lineHeight: pixel(theme.typography.subheading.lineHeight),
      dataAutomationId,
    }),
    variants
  )
);

// @ts-expect-error - TS2322 - Type 'AbstractComponent<Diff<StylingType, { style?: StyleObject; }>, any>' is not assignable to type 'ComponentType<TextProps>'.
export const Copy: React.ComponentType<TextProps> = noEmpty(
  styledDiv(
    ({theme, style, 'data-automation-id': dataAutomationId}: StylingType) => ({
      color: theme.Text.labelColor,
      ...theme.typography.copy,
      ...style,
      lineHeight: pixel(theme.typography.copy.lineHeight),
      dataAutomationId,
    }),
    variants
  )
);

// @ts-expect-error - TS2322 - Type 'AbstractComponent<Diff<StylingType, { style?: StyleObject; }>, any>' is not assignable to type 'ComponentType<TextProps>'.
export const FinePrint: React.ComponentType<TextProps> = noEmpty(
  styledDiv(
    ({theme, style, 'data-automation-id': dataAutomationId}: StylingType) => ({
      color: theme.Text.labelColor,
      ...theme.typography.finePrint,
      ...style,
      lineHeight: pixel(theme.typography.finePrint.lineHeight),
      dataAutomationId,
    }),
    variants
  )
);

// @ts-expect-error - TS2322 - Type 'AbstractComponent<Diff<StylingType, { style?: StyleObject; }>, any>' is not assignable to type 'ComponentType<TextProps>'.
export const Label: React.ComponentType<TextProps> = noEmpty(
  styledDiv(
    ({theme, style, 'data-automation-id': dataAutomationId}: StylingType) => ({
      color: theme.Text.labelColor,
      ...theme.typography.label,
      ...style,
      lineHeight: pixel(theme.typography.label.lineHeight),
      dataAutomationId,
    }),
    variants
  )
);
